import styled, { css } from "styled-components/macro";
import type { ElearningThemeInterface } from "themes/elearningInterface.theme";

interface Props {
  theme: ElearningThemeInterface;
  selected?: boolean;
  $nestingLevel: number;
}

export const StyledNavigationMenuItem = styled.nav<Props>`
  height: 3rem;
  // IDEA: add padding-right: 2rem; to account for big font mode
  padding-left: ${({ $nestingLevel }: Props) => ($nestingLevel > 0 ? `${3 + 1.5 * ($nestingLevel - 1)}rem` : "1rem")};
  display: flex;
  align-items: center;
  border-radius: 4px;
  font-size: ${(props: Props) => props.theme.font.size._14};

  ${(props: Props) =>
    props.selected &&
    css`
      font-weight: ${props.theme.font.weight.bold};
      color: ${(props: Props) => props.theme.palette.secondary.brand};
      background-color: ${(props: Props) => props.theme.palette.secondary._900};
      font-weight: ${(props: Props) => props.theme.font.weight.bold};
    `}

  &:hover {
    cursor: pointer;
    color: ${(props: Props) => props.theme.palette.secondary.brand};
    background-color: ${(props: Props) => props.theme.palette.neutral.white};
    background-color: ${(props: Props) => props.theme.palette.primary._950};
  }
`;
